const API_BASE = '/api/cms';

async function api(path, { method = 'GET', body, isFormData = false } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: isFormData ? undefined : { 'Content-Type': 'application/json' },
    body: isFormData ? body : (body ? JSON.stringify(body) : undefined),
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

const toFormData = (fields = {}) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    formData.append(key, value);
  });
  return formData;
};

export const CmsService = {
  // Public feed (published only) — used by the homepage carousel
  listPublicPosts: (type, limit = 3) => api(`/posts?type=${encodeURIComponent(type)}&limit=${limit}`),

  // Admin — full list including drafts
  listAdminPosts: (type) => api(`/posts/admin${type ? `?type=${encodeURIComponent(type)}` : ''}`),
  getPost: (id) => api(`/posts/${id}`),

  // Public — single published post + sidebar aggregates, used by the detail pages
  getPublicPost: (id) => api(`/posts/public/${id}`),
  getSidebarMeta: (types = ['news', 'blog']) => api(`/sidebar?types=${encodeURIComponent(types.join(','))}`),

  // Public — comments on a post
  listComments: (postId, { limit = 10, offset = 0 } = {}) => api(`/posts/${postId}/comments?limit=${limit}&offset=${offset}`),
  addComment: (postId, fields) => api(`/posts/${postId}/comments`, { method: 'POST', body: fields }),

  // Admin — comment moderation queue
  listAdminComments: ({ status, postId } = {}) => {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (postId) params.set('post_id', postId);
    const qs = params.toString();
    return api(`/comments/admin${qs ? `?${qs}` : ''}`);
  },
  updateCommentStatus: (id, status) => api(`/comments/${id}`, { method: 'PATCH', body: { status } }),
  deleteComment: (id) => api(`/comments/${id}`, { method: 'DELETE' }),

  // Admin — inline image upload for the article content editor
  uploadImage: (file) => api('/upload-image', { method: 'POST', body: toFormData({ image: file }), isFormData: true }),

  createPost: (fields) => api('/posts', { method: 'POST', body: toFormData(fields), isFormData: true }),
  updatePost: (id, fields) => api(`/posts/${id}`, { method: 'PUT', body: toFormData(fields), isFormData: true }),
  deletePost: (id) => api(`/posts/${id}`, { method: 'DELETE' }),
};

export default CmsService;
